import React from "react";
import Card from "./Card";
import '../../styles/KeyInsightsCard.css';
import { AGENT_TYPES } from "../../constants/agentTypes";

const Stat = ({
  value, label, hint, title, icon, labelIcon, agentName
}) => (
  <div className="insight-stat">
    <div className="stat-header">
      <div className="stat-title">{title}</div>
      <img src={icon} alt="FolderSearchIcon" className="stat-icon" />
    </div>
    <div className="stat-value-line">
      <span className="stat-value">
        {value}
        {' '}
        
      </span>
      {hint && <span className={`stat-hint ${ agentName === AGENT_TYPES.ELIGIBILITY_REVIEW ? "eligible-agent" : ""}`} >{hint}</span>}
    </div>

    <div className="stat-label">
      <img src={labelIcon} alt="stat icon" className="stat-icon" />
      {' '}
      <span>{label}</span>
    </div>

  </div>
);

const KeyInsightsCard = ({ stats = [],agentName }) => (
  <div className="insights-cards-wrapper">
    {stats.map((s, i) => (
      <Card className="insights-card" >
        <Stat
          title={s.title}
          value={s.value}
          label={s.label}
          hint={s.hint}
          icon={s.icon}
          labelIcon={s.labelIcon}
          agentName={agentName}
        />
      </Card>
    ))}
  </div>
);

export default KeyInsightsCard;
